// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"534":"32fec157","975":"2ff7ccb9"}[chunkId] + ".chunk.js";
};